module.exports = __webpack_public_path__ + "img/footer-logo.74cfe8eb.png";